import { Suspense } from 'react';

import { SetLastSeenToNow } from '@/features/app/header/useStoredReleaseNotes';
import { FeedbackCareMfe } from '@/features/microfrontends/FeedbackCareMfe';
import { isUnderMaintenance } from '@/features/systemMaintenance/systemMaintenance';
import SystemMaintenanceState from '@/features/systemMaintenance/SystemMaintenanceState';
import AboutElectricVehicles from './eMobilityPages/AboutElectricVehicles';
import BatteryHealth from './eMobilityPages/BatteryHealth';
import BookingOptions from './functionPages/BookingOptions';
import DamagesInbox from './functionPages/DamagesInbox';
import DiagnosticsData from './functionPages/DiagnosticsData';
import ExportDiagnosticData from './functionPages/ExportDiagnosticData';
import ManageAppointments from './functionPages/ManageAppointments';
import OverviewInfo from './functionPages/OverviewInfo';
import ProActiveMaintenanceInfo from './functionPages/ProActiveMaintenanceInfo';
import SmartphoneTabletView from './functionPages/SmartphoneTabletView';
import WorkshopAssignment from './functionPages/WorkshopAssignment';
import Welcome from './servicePages/Welcome';
import WhatsNew from './servicePages/WhatsNew';

export enum InfoDialogContentType {
    welcome = 'welcome',
    whatsNew = 'whats_new',
    feedback = 'feedback',
    booking_options = 'booking_options',
    overview = 'overview',
    workshopAssignment = 'workshop_assignment',
    diagnosticsData = 'diagnostics_data',
    manageAppointments = 'manage_appointments',
    proactiveMaintenance = 'proactivemaintenance',
    damagesInbox = 'damages_inbox',
    smartphoneTabletView = 'smartphone_tablet_view',
    exportDiagnosticData = 'export_diagnostics_data',
    aboutElectricVehicles = 'electric_vehicles',
    batteryHealth = 'battery_health',
}

type InfoDialogDisplaySectionProps = {
    section: InfoDialogContentType;
    setLastSeenToNow: SetLastSeenToNow;
    feedbackOrigin?: string;
};
const InfoDialogDisplaySection = ({ section, setLastSeenToNow, feedbackOrigin }: InfoDialogDisplaySectionProps) => {
    return <Suspense fallback="">{renderComponent()}</Suspense>;

    function renderComponent() {
        switch (section) {
            case InfoDialogContentType.welcome:
                return <Welcome />;
            case InfoDialogContentType.feedback:
                return isUnderMaintenance() ? <SystemMaintenanceState /> : <FeedbackCareMfe feedbackOrigin={feedbackOrigin} />;
            case InfoDialogContentType.whatsNew:
                return <WhatsNew setLastSeenToNow={setLastSeenToNow} />;
            case InfoDialogContentType.booking_options:
                return <BookingOptions />;
            case InfoDialogContentType.overview:
                return <OverviewInfo />;
            case InfoDialogContentType.workshopAssignment:
                return <WorkshopAssignment />;
            case InfoDialogContentType.diagnosticsData:
                return <DiagnosticsData />;
            case InfoDialogContentType.manageAppointments:
                return <ManageAppointments />;
            case InfoDialogContentType.proactiveMaintenance:
                return <ProActiveMaintenanceInfo />;
            case InfoDialogContentType.damagesInbox:
                return <DamagesInbox />;
            case InfoDialogContentType.smartphoneTabletView:
                return <SmartphoneTabletView />;
            case InfoDialogContentType.exportDiagnosticData:
                return <ExportDiagnosticData />;
            case InfoDialogContentType.aboutElectricVehicles:
                return <AboutElectricVehicles />;
            case InfoDialogContentType.batteryHealth:
                return <BatteryHealth />;
        }
    }
};
export default InfoDialogDisplaySection;
